export default {
  getAgreementDefault: (state) => state.agreementDefault,
};
